var React = require('react');

function ChevronRightBlack (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.163,1.653l0.708,-0.708l-0.708,-0.708","style":{"fill":"none","fillRule":"nonzero","stroke":"#424b54","strokeWidth":"0.3px"}}));
}

ChevronRightBlack.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 2 2","version":"1.1","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"}};

module.exports = ChevronRightBlack;

ChevronRightBlack.default = ChevronRightBlack;
